import React from 'react';
import {Pagination} from 'react-bootstrap';

const PaginationControls = ({currentPage, totalPages, onPageChange}) => {
    //Don't render any pagination if the data is 1 page or less
    if (totalPages <= 1) return null;

    //Calculate so there is always 5 pages you can chose from in pagination
    const windowSize = 5;
    const half = Math.floor(windowSize / 2);
    let start = Math.max(0, currentPage - half);
    let end = Math.min(totalPages - 1, start + windowSize - 1);
    if (end - start < windowSize - 1) {
        start = Math.max(0, end - windowSize + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
        pages.push(i);
    }

    return (
        <Pagination className="justify-content-center mt-3">
            <Pagination.First onClick={() => onPageChange(0)} disabled={currentPage === 0}/>
            <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 0}/>
            {pages.map(p => (
                <Pagination.Item key={p} active={p === currentPage} onClick={() => onPageChange(p)}>
                    {p + 1}
                </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={currentPage >= totalPages - 1}/>
            <Pagination.Last onClick={() => onPageChange(totalPages - 1)} disabled={currentPage >= totalPages - 1}/>
        </Pagination>
    );
};

export default PaginationControls;
